import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Cordwoods


export interface Cordwood {
    id: ID;

    
    internalKey: string;

    
    timberKey: string;

    
    volume: number;

    
    measurementType: CordwoodMeasurementType;

    
    volumeM3: number;

    
    timberTypeId: ID;

    
    classId: ID;

    
    commited: boolean;

    
    storageId: ID;

    
    locationId: ID;

    
    cuttingId: ID;

    
    shipmentId?: ID;

    
    createdAt: Date;

    
    localCreatedAt?: Date;

    
    localUpdatedAt?: Date;

    
    localDeletedAt?: Date;

    
    description?: string;

    
    scopeGroupId: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            internalKey?: string,
        
    
    

            timberKey?: string,
        
    
    
volumeFrom?: number,
            volumeTo?: number,
        
    
    

            measurementType?: CordwoodMeasurementType,
        
    
    

            timberTypeId: ID[],
        
    
    

            classId: ID[],
        
    
    

            shipmentId?: ID,
        
    
    shipmentIdInclude: boolean,
localCreatedAtFrom?: Date,
            localCreatedAtTo?: Date,
        
    
    localCreatedAtInclude: boolean,



        storageIdRefs?: ID[],
        cuttingIdRefs?: ID[],
        shipmentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateCordwood {
    
    
    timberKey: string;

    
    volume: number;

    
    measurementType: CordwoodMeasurementType;

    
    
    timberTypeId: ID;

    
    classId: ID;

    
    commited: boolean;

    
    storageId: ID;

    
    
    
    shipmentId?: ID;

    
    
    localCreatedAt?: Date;

    
    localUpdatedAt?: Date;

    
    localDeletedAt?: Date;

    
    description?: string;

    
    }


export interface UpdateCordwood {
    
    
    
    volume: number;

    
    measurementType: CordwoodMeasurementType;

    
    
    timberTypeId: ID;

    
    classId: ID;

    
    commited: boolean;

    
    
    
    
    shipmentId?: ID;

    
    
    
    localUpdatedAt?: Date;

    
    localDeletedAt?: Date;

    
    description?: string;

    
    }

export interface PresentationCordwoodRequest {
    list: ListRequest,
    filter: {
        timberKey: string,
        timberKeyOr: boolean,
        internalKey: string,
        internalKeyOr: boolean,
        storageIdRefs?: ID[],
        cuttingIdRefs?: ID[],
        shipmentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryCordwood {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Cordwood): PrimaryCordwood | undefined {
        return entity ? new PrimaryCordwood(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryCordwood {
        return new PrimaryCordwood(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryCordwood {
        let vals = path?.split('/');
        return new PrimaryCordwood(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryCordwood[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Cordwood): string {
    let fields = entity ? [
    entity.timberKey,
            entity.internalKey,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityCordwood {
    id: PrimaryCordwood;
    data: UpdateCordwood;


    constructor(id: PrimaryCordwood, data: UpdateCordwood) {
        this.id = id;
        this.data = data;
    }
}

export interface AssignShipmentCordwood {
    id: ID;
    volume: number;
    shipmentId: ID;
    measurementType: CordwoodMeasurementType;
}

export interface CordwoodTotalQueryRequest {
    cuttingId?: ID,
    storageId?: ID,
    shipmentId?: ID,
    shipmentDefined?: boolean,
}

export interface CordwoodTotalQueryResult {
    commited: boolean,
    totalCount: number,
    totalVolume: number,
}
